import React, { useState } from 'react';
import { X } from 'lucide-react';

const STORAGE_KEY = 'instagram_osint_welcome_dismissed';

/** Dismissible first-visit note. The living checklist is FlowCoach, not this card. */
export const InstagramWelcome: React.FC = () => {
    const [visible, setVisible] = useState(() => {
        try {
            return localStorage.getItem(STORAGE_KEY) !== '1';
        } catch {
            return true;
        }
    });

    const dismiss = () => {
        setVisible(false);
        try {
            localStorage.setItem(STORAGE_KEY, '1');
        } catch {
            /* ignore */
        }
    };

    if (!visible) return null;

    return (
        <div
            className="rounded-lg border border-border bg-card p-3 relative text-sm"
            role="region"
            aria-label="Welcome to Instagram leads"
            data-tour="instagram-welcome"
        >
            <button
                type="button"
                onClick={dismiss}
                className="absolute top-2 right-2 p-1 rounded text-muted-foreground hover:bg-secondary"
                aria-label="Dismiss welcome"
            >
                <X className="w-4 h-4" />
            </button>
            <div className="pr-7 space-y-1.5">
                <p className="font-medium">First time here</p>
                <p className="text-muted-foreground text-[13px] leading-snug">
                    Pick the <strong className="text-foreground">same case</strong> as Workbench.
                    If you already have an <strong className="text-foreground">@handle</strong>, paste it.
                    If you only have a <strong className="text-foreground">phone, email, or UPI</strong>, search
                    records we already hold — then paste the bio or screenshots and save wallets onto the graph.
                </p>
                <button
                    type="button"
                    onClick={dismiss}
                    className="text-xs text-primary underline"
                >
                    Dismiss
                </button>
            </div>
        </div>
    );
};

export default InstagramWelcome;
